import { CNPJ } from "cpf_cnpj";

const cnpj = (value) => {
  return value ? CNPJ.isValid(value) : true;
};

export default cnpj;
